// TODO: delete this folder when cleaning up bulk_operations_floating_toolbar

import { useEffect, useRef, useMemo } from 'react';
import type { CSSProps } from '@compiled/react';
import { useBulkActionsBar } from '../bulk-actions-bar-controller/index.tsx';
import {
	ANIMATION_DURATION_MS,
	OFFSET,
	HEIGHT_ANIMATION_DURATION_SECONDS,
	VISIBILITY_ANIMATION_DURATION_SECONDS,
} from './constants.tsx';

// This hook is used to animate the bulk actions bar when it is closed.
export const useCloseGracefully = (): CSSProps<unknown> => {
	const [{ isOpen, shouldCloseGracefully }, { setHasClosedGracefully }] = useBulkActionsBar();
	const timeout = useRef<NodeJS.Timeout>();

	useEffect(() => {
		if (!isOpen && shouldCloseGracefully) {
			// We need to wait for the height animation to finish before we can set the visibility to hidden.
			timeout.current = setTimeout(setHasClosedGracefully, ANIMATION_DURATION_MS + OFFSET);
		}

		return () => {
			if (timeout.current) {
				clearTimeout(timeout.current);
			}
		};
	}, [setHasClosedGracefully, timeout, isOpen, shouldCloseGracefully]);

	return useMemo<CSSProps<unknown>>(
		() => ({
			visibility: isOpen ? 'visible' : 'hidden',
			transition: shouldCloseGracefully
				? `height ${HEIGHT_ANIMATION_DURATION_SECONDS}s ease-in, visibility ${VISIBILITY_ANIMATION_DURATION_SECONDS}s ease-in`
				: 'none',
			...(!isOpen ? { height: '0px !important' } : {}),
		}),
		[isOpen, shouldCloseGracefully],
	);
};
